import { render, staticRenderFns } from "./mod-06.vue?vue&type=template&id=3b86e913&scoped=true&"
import script from "./mod-06.vue?vue&type=script&lang=js&"
export * from "./mod-06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86e913",
  null
  
)

export default component.exports